import { Settinglable } from "../models/setting"
import { API_PREFIX } from "./constant";
import { Request } from "./request";

/*
 * @Descripttion: 
 * @version: 
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-09-12 14:25:56
 * @LastEditors: linxi
 * @LastEditTime: 2025-09-12 16:41:22
 */
export interface FeesSettingParams {
  invoiceNumberConfigs?: any[]
  functions: Settinglable[]
  tenantCustomizePayMethods?: any[]
}


export function getSaveFeesSetting(body: FeesSettingParams): Request {
  return {
    url: `${API_PREFIX}/blade-user/setting/saveFeesSetting`,
    method: 'POST',
    body,
  }
}



export function getFeesSetting(): Request {
  return {
    url: `${API_PREFIX}/blade-user/setting/getFeesSetting`,
    method: 'GET',
  }
}